<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <!-- Header Section -->
            <div
              class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
            >
              <div class="flex items-center gap-2">
                <div>
                  <h2 class="text-2xl font-bold text-gray-800">
                   Learner
                    <span class="text-textblues text-lg font-medium ml-2"
                      >({{ count_list || 0 }})</span
                    >
                  </h2>
                  <p class="text-sm text-gray-500 mt-0.5">
                    Manage and view all Learner records
                  </p>
                </div>
              </div>
              <router-link :to="{ name: 'AdminDashboards' }">
                <button
                  class="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-xl transition-all duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Back to Dashboard
                </button>
              </router-link>
            </div>

            <!-- Search Section -->
            <div class="flex justify-end">
              <div class="relative w-full max-w-80">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="searching"
                  @input="getstudent(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Filter Section -->
            <div class="bg-gray-50 rounded-2xl p-5 border border-gray-100">
              <div class="flex items-center gap-2 mb-4">
                <h3 class="font-semibold text-gray-700">Filter learner</h3>
              </div>
              <form
                @submit.prevent="filterData"
                class="flex flex-col lg:flex-row flex-wrap gap-3"
              >
                <!-- <select
                  name="course"
                  id="course"
                  v-model="selectPatch"
                  @change="filterData()"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="" disabled selected>Select Batch</option>
                  <option
                    v-for="batch in batchs"
                    :key="batch.year"
                    :value="batch.year"
                  >
                    {{ batch.year }}
                  </option>
                </select>
                <select
                  name="program"
                  id="program"
                  v-model="selectprogram"
                  @change="departmentget(selectprogram), filterData()"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="" disabled selected>Select Program</option>
                  <option
                    v-for="program in programs"
                    :key="program.name"
                    :value="program.name"
                  >
                    {{ program.name }}
                  </option>
                </select>

                <select
                  name="semester"
                  id="semester"
                  v-model="selectsemester"
                  @change="filterData()"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="" disabled selected>Select Semester</option>
                  <option value="I">I</option>
                  <option value="II">II</option>
                  <option value="III">III</option>
                  <option value="IV">IV</option>
                  <option value="V">V</option>
                  <option value="VI">VI</option>
                </select> -->
                <!-- Batch -->
                <select
                  v-model="selectBatchId"
                  @change="onBatchFilterChange"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700"
                >
                  <option value="">Select Batch</option>

                  <option
                    v-for="batch in batchs"
                    :key="batch.id"
                    :value="batch.id"
                  >
                    {{ batch.year }}
                  </option>
                </select>

                <!-- Program -->
                <select
                  v-model="selectprogram"
                  @change="onProgramFilterChange"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700"
                >
                  <option value="">Select Program</option>

                  <option
                    v-for="program in programs"
                    :key="program.id"
                    :value="program.id"
                  >
                    {{ program.name }}
                  </option>
                </select>

                <!-- Semester -->
                <select
                  v-model="selectsemester"
                  @change="filterData(1)"
                  class="bg-white rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700"
                >
                  <option value="">Select Semester</option>

                  <option
                    v-for="semester in semesters"
                    :key="semester.id"
                    :value="semester.id"
                  >
                    {{ semester.semester }}
                  </option>
                </select>
                <div class="flex items-center gap-3">
                  <button
                    type="button"
                    @click="clearFilters"
                    class="text-gray-500 hover:text-red-500 transition-colors flex items-center text-sm font-medium gap-1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    Clear All
                  </button>
                </div>
              </form>
            </div>

            <!-- Filter Applied Tags -->
            <div v-if="filtered" class="flex flex-col gap-3">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="text-sm text-gray-500">Filters applied:</span>

                <div
                  v-if="selectedBatchName"
                  class="flex items-center gap-1 bg-blue-100 text-textblues px-3 py-1 rounded-full text-xs font-medium"
                >
                  Batch: {{ selectedBatchName }}
                  <button
                    @click="removeFilter('batch')"
                    class="ml-1 hover:text-red-500"
                  >
                    &times;
                  </button>
                </div>

                <div
                  v-if="selectedProgramName"
                  class="flex items-center gap-1 bg-blue-100 text-textblues px-3 py-1 rounded-full text-xs font-medium"
                >
                  Program: {{ selectedProgramName }}
                  <button
                    @click="removeFilter('program')"
                    class="ml-1 hover:text-red-500"
                  >
                    &times;
                  </button>
                </div>
                <div
                  v-if="selectedSemesterName"
                  class="flex items-center gap-1 bg-blue-100 text-textblues px-3 py-1 rounded-full text-xs font-medium"
                >
                  Semester: {{ selectedSemesterName }}
                  <button
                    @click="removeFilter('semester')"
                    class="ml-1 hover:text-red-500"
                  >
                    &times;
                  </button>
                </div>
                <!-- <div
                  v-if="selectdepartment"
                  class="flex items-center gap-1 bg-blue-100 text-textblues px-3 py-1 rounded-full text-xs font-medium"
                >
                  Department: {{ selectdepartment }}
                  <button
                    @click="removeFilter('department')"
                    class="ml-1 hover:text-red-500"
                  >
                    &times;
                  </button>
                </div> -->
                <div
                  v-if="selectsection"
                  class="flex items-center gap-1 bg-blue-100 text-textblues px-3 py-1 rounded-full text-xs font-medium"
                >
                  Section: {{ selectsection }}
                  <button
                    @click="removeFilter('section')"
                    class="ml-1 hover:text-red-500"
                  >
                    &times;
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Section -->
            <div class="mt-2">
              <div
                class="overflow-x-auto rounded-2xl border border-gray-100 bg-white shadow-sm"
              >
                <table class="min-w-full divide-y divide-gray-100">
                  <thead>
                    <tr class="bg-gray-100">
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold rounded-l-xl text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> S.No </span>
                      </th>
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1">
                          Learner Info
                        </span>
                      </th>
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1">
                          Mobile number
                        </span>
                      </th>
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> Batch </span>
                      </th>
                      <!-- <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1">
                          Department
                        </span>
                      </th> -->
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold rounded-r-xl text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> Program </span>
                      </th>
                      <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> Semester </span>
                      </th>

                      <th
                        class="px-5 py-4 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1">
                          Created at
                        </span>
                      </th>
                    </tr>
                  </thead>

                  <tbody v-if="loading" class="bg-gray-50">
                    <tr>
                      <td colspan="7" class="text-center py-12">
                        <div class="flex items-center justify-center">
                          <div
                            class="animate-spin rounded-full h-8 w-8 border-b-2 border-blues"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-else class="divide-y divide-gray-50">
                    <template v-if="student_list.length > 0">
                      <tr
                        v-for="(list, index) in student_list"
                        :key="index"
                        class="hover:bg-blue-50/30 transition-all duration-150 group"
                      >
                        <td
                          class="px-5 py-3.5 text-sm text-gray-500 font-medium border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center justify-center w-7 h-7 bg-gray-100 rounded-lg text-xs font-semibold text-gray-600 group-hover:bg-blue-100 group-hover:text-textblues transition"
                          >
                            {{ (currentPage - 1) * pageSize + index + 1 }}
                          </span>
                        </td>

                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <div class="flex flex-col">
                            <p
                              class="font-semibold text-gray-800 uppercase text-xs flex items-center gap-2"
                            >
                              <span
                                class="w-7 h-7 rounded-full bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center text-xs font-bold text-textblues"
                              >
                                {{
                                  (list.user_name || "U")
                                    .charAt(0)
                                    .toUpperCase()
                                }}
                              </span>
                              {{ list.user_name || "---" }}
                            </p>
                            <div
                              class="flex items-center gap-3 mt-1 text-xs text-gray-500"
                            >
                              <span class="flex items-center gap-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-3 w-3"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                  />
                                </svg>
                                {{ list.email }}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <span
                            class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-gray-500 text-xs font-medium"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-3 w-3"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                              />
                            </svg>
                            {{ list.mobile || "None" }}
                          </span>
                        </td>

                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <span
                            class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-gray-500 text-xs font-medium"
                          >
                            {{
                              list.batch
                                ? list.batch.split("__").slice(0, -1).join("__")
                                : "---"
                            }}
                          </span>
                        </td>

                        <!-- <td class="px-5 py-3.5 border-r border-gray-200">
                          <span class="text-gray-500 text-xs">{{
                            list.department || "---"
                          }}</span>
                        </td> -->
                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <span class="text-gray-500 text-xs">{{
                            list.program || "---"
                          }}</span>
                        </td>
                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <span
                            class="inline-flex items-center justify-center w-10 h-7 rounded-lg text-gray-500 text-xs font-semibold"
                          >
                            {{
                              list.semester
                                ? list.semester.split("__").pop()
                                : "---"
                            }}
                          </span>
                        </td>

                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <span
                            class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-gray-700 text-xs font-medium"
                          >
                            {{
                              list.created_at
                                ? formatDate(list.created_at)
                                : "---"
                            }}
                          </span>
                        </td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td colspan="7" class="px-5 py-12 text-center">
                        <div class="flex flex-col items-center justify-center">
                          <div
                            class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-3"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-8 w-8 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                              />
                            </svg>
                          </div>
                          <h3 class="text-lg font-semibold text-gray-700">
                            No learner Found
                          </h3>
                          <p class="text-sm text-gray-400 mt-1">
                            Try adjusting your search or filters
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination -->
              <!-- <div class="mt-6">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="getstudent"
                />
              </div> -->
              <div
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 mb-6 relative"
              >
                <!-- PAGE SIZE -->
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>

                <!-- PAGINATION -->
                <div v-if="totalPages > 1" class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages"
                    ref="paginationRef"
                    @page-changed="filterData"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      student_list: [],
      loading: false,
      messages: {
        text: "",
        type: "null",
      },
      selectsemester: "",
      selectBatchId: "",
      selectdepartment: "",
      selectprogram: "",
      selectsession: "",
      selectsection: "",
      selectpractical: "",
      selectelective: "",
      departments: [],
      batchs: [],
      programs: [],
      sections: [],
      practicals: [],
      electives: [],
      semesters: [],
      count_list: "",
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      searching: "",
      filtered: false,
    };
  },
  components: {
    SideBar,
    FlashMessage,
    Pagination,
  },
  async created() {
    await this.getstudent(1);
    // await this.programget();
    await this.batchget();
    // await this.sectionget();
  },

  computed: {
    ...mapGetters(["userInfo"]),
    selectedBatchName() {
      const batch = this.batchs.find((item) => item.id == this.selectBatchId);
      return batch ? batch.year : "";
    },

    selectedProgramName() {
      const program = this.programs.find(
        (item) => item.id == this.selectprogram,
      );
      return program ? program.name : "";
    },

    selectedSemesterName() {
      const semester = this.semesters.find(
        (item) => item.id == this.selectsemester,
      );
      return semester ? semester.semester : "";
    },
  },

  methods: {
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getstudent(1);
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}`;
    },
    // async programget() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`,
    //     )
    //     .then((res) => {
    //       if (res.data.status == 200) {
    //         this.programs = res.data.data;
    //       }
    //     });
    // },
    async batchget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.batchs = res.data.data;
          }
        });
    },
    async onBatchFilterChange() {
      this.selectprogram = "";
      this.selectsemester = "";

      this.programs = [];
      this.semesters = [];

      if (!this.selectBatchId) {
        this.getstudent(1);
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${this.selectBatchId}&Key=${this.userInfo.token_key}`,
        );

        if (res.data.status === 200) {
          this.programs = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }

      this.filterData(1);
    },
    async onProgramFilterChange() {
      this.selectsemester = "";
      this.semesters = [];

      if (!this.selectprogram) return;

      try {
        const deptRes = await axios.get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${this.selectprogram}`,
        );

        if (deptRes.data.status === 200 && deptRes.data.data.length > 0) {
          const departmentId = deptRes.data.data[0].id;

          const semesterRes = await axios.get(
            `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${departmentId}&batch__id=${this.selectBatchId}`,
          );

          if (semesterRes.data.status === 200) {
            this.semesters = semesterRes.data.data;
          }
        }
      } catch (error) {
        console.log(error);
        this.semesters = [];
      }

      this.filterData(1);
    },
    async departmentget(program) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__name=${program}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.departments = res.data.data;
          }
        });
    },
    async sectionget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.sections = res.data.data;
          }
        });
    },

    async getstudent(page) {
      this.currentPage = page;
      this.loading = true;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-profile-details-get/?Key=${this.userInfo.token_key}&search=${this.searching}&page=${page}&page_size=${this.pageSize}&user__demo_user=false`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.student_list = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
            this.currentPage = res.data.current_page;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // async searchUserValue() {
    //   if (!this.searching) {
    //     await this.getstudent(1);
    //     return;
    //   }
    //   this.loading = true;
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/student-profile-details-get/?search=${this.searching}&page_size=${this.pageSize}&Key=${this.userInfo.token_key}&user__demo_user=false`,
    //     )
    //     .then((res) => {
    //       if (res.data.data.status == 200) {
    //         this.student_list = res.data.data.data;
    //         this.count_list = res.data.total;
    //         this.totalPages = res.data.total_page;
    //         this.currentPage = res.data.current_page;
    //       }
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },

    async filterData(page = 1) {
      this.loading = true;

      try {
        const params = {
          Key: this.userInfo.token_key,
          page,
          page_size: this.pageSize,
          user__demo_user: false,
        };

        if (this.searching) {
          params.search = this.searching;
        }

        if (this.selectBatchId) {
          params["batch__id"] = this.selectBatchId;
        }

        if (this.selectprogram) {
          params["program__id"] = this.selectprogram;
        }

        if (this.selectsemester) {
          params["semester__id"] = this.selectsemester;
        }

        const res = await axios.get(
          `${process.env.VUE_APP_API}/student-profile-details-get/`,
          { params },
        );

        if (res.data.data.status === 200) {
          this.filtered = true;
          this.student_list = res.data.data.data;
          this.count_list = res.data.total;
          this.totalPages = res.data.total_page;
          this.currentPage = res.data.current_page;
        } else {
          this.student_list = [];
          this.count_list = 0;
        }
      } catch (error) {
        console.log(error);
        this.student_list = [];
        this.count_list = 0;
      } finally {
        this.loading = false;
      }
    },
    clearFilters() {
      this.filtered = false;

      this.selectBatchId = "";
      this.selectprogram = "";
      this.selectsemester = "";

      this.programs = [];
      this.semesters = [];

      this.getstudent(1);
    },
    clearSearch() {
      this.searching = "";
      this.getstudent(1);
    },
    removeFilter(type) {
      switch (type) {
        case "semester":
          this.selectsemester = "";
          break;
        case "batch":
          this.selectBatchId = "";
          break;
        case "program":
          this.selectprogram = "";
          break;
        case "department":
          this.selectdepartment = "";
          break;
        case "section":
          this.selectsection = "";
          break;
      }
      this.filterData();
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

/* Custom scrollbar */
.heightfix::-webkit-scrollbar {
  width: 6px;
}

.heightfix::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
